import Cookies from 'js-cookie'
var CryptoJS = require("crypto-js");
import {
  getToken
} from './token';
import { getFaceConfig } from "./faceConfig";

/**
 * [通过参数名获取url中的参数值]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param  {[string]} queryName [参数名]
 * @return {[string]}           [参数值]
 */
export function getQueryValue(queryName) {
  var query = decodeURI(window.location.search.substring(1));
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] == queryName) {
      return pair[1];
    }
  }
  return null;
}

export function getPayRollHost() {
  const hostName = window.location.host;
  const protocol = window.location.protocol;
  let payrollHostName = '0.0.0.0:8090'
  if (hostName === '0.0.0.0:8080') {
    payrollHostName = '0.0.0.0:8090'
  } else if (hostName === 'localhost:8080') {
    payrollHostName = 'localhost:8090'
  } else if (hostName === 's.anxinzp.com') {
    payrollHostName = 's-share.anxinzp.com'
  } else if (hostName === 's.anxingongchang.com') {
    payrollHostName = 's-share.anxingongchang.com'
  } else if (hostName === 's.huixiananxin.com') {
    payrollHostName = 's-share.huixiananxin.com'
  } else if (hostName.indexOf('yunrenshi.net') > -1) {
    payrollHostName = 's-share.yunrenshi.net'
  } else if (hostName.indexOf('pugonganxin.com') > -1) {
    payrollHostName = 's-share.pugonganxin.com'
  } else if (hostName.indexOf('anxinjthr.com') > -1) {
    payrollHostName = 's-share.anxinjthr.com'
  } else if (hostName.indexOf('anxinshangban.com') > -1) {
    payrollHostName = 's-share.anxinshangban.com'
  }
  return `${protocol}//${payrollHostName}`
}

export function setCrossDomain() {
  let domainVal = !!location.origin.match(/(0.0.0.0)|(192.168)|(localhost)/) ? '' :
    document.domain.split('.').slice(-2).join('.');

  window.document.domain = document.domain.split('.').slice(-2).join('.');
  Cookies.set('saas_app_accessToken', getToken(), domainVal ? {
    domain: domainVal
  } : {})
}

export function setCrossDomainUrl(url) {
  let domainVal = !!location.origin.match(/(0.0.0.0)|(192.168)|(localhost)/) ? '' :
    document.domain.split('.').slice(-2).join('.');

  window.document.domain = document.domain.split('.').slice(-2).join('.');
  Cookies.set('saas_local_url', url, domainVal ? {
    domain: domainVal
  } : {})
}
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if (arr = document.cookie.match(reg))

    return unescape(arr[2]);
  else
    return null;
}
// export function getDomain() {
//   console.log(document.domain.split('.').slice(-2).join('.'))

//   const hostName = window.location.host;
//   let myDomain = '0.0.0.0'
//   if (hostName === '0.0.0.0:8080') {
//     myDomain = '0.0.0.0'
//   } else if (hostName === 'localhost:8080') {
//     myDomain = 'localhost'
//   } else if (hostName === 'saas-staff-dev.julanling.com') {
//     myDomain = 'julanling.com'
//   } else if (hostName === 's-test.yunrenshi.net') {
//     myDomain = 'yunrenshi.net'
//   } else if (hostName === 'saas-staff-pre.julanling.com') {
//     myDomain = 'julanling.com'
//   } else if (hostName === 's.yunrenshi.net') {
//     myDomain = 'yunrenshi.net'
//   }
//   return myDomain
// }
export const digit = function (num) {
  return num >= 10 ? String(num).split('') : ['0', String(num)]
}

/**
 * 从时间戳中获取格式化的时间
 * @param stamp 选传，不传则使用当前时间
 * @returns {{date: number, dayOfWeek: string, month: number, hour: number, year: number, minute: number, second: number}}
 */
export const getTime = function (stamp) {
  let dateObj = stamp ? new Date(stamp) : new Date()
  let day = dateObj.getDay()
  let strWeek = ['日', '一', '二', '三', '四', '五', '六']
  return {
    year: dateObj.getFullYear(),
    month: dateObj.getMonth() + 1,
    date: dateObj.getDate(),
    // 星期几
    dayOfWeek: strWeek[day],
    // 24小时制的小时
    hour: digit(dateObj.getHours()).join(''),
    hourArr: digit(dateObj.getHours()),
    minute: digit(dateObj.getMinutes()).join(''),
    minuteArr: digit(dateObj.getMinutes()),
    second: digit(dateObj.getSeconds()).join(''),
    secondArr: digit(dateObj.getSeconds())
  }
}

export const debounce = function (func, wait) {
  let timeId
  return function () {
    timeId && clearTimeout(timeId)
    timeId = setTimeout(([...args]) => {
      func.apply(this, args)
    }, wait)
  }
}

export const setJsonp = function (url, params = null) {
  return new Promise((resolve, reject) => {
    let randomStr = (function () {
      return (Math.floor(Math.random() * 100000) * Date.now()).toString(16)
    })()
    let sc = document.createElement('script')
    let paramsStr = ''
    if (params) {
      Object.keys(params).forEach(key => {
        paramsStr += `&${key}=${params[key]}`
      })
    }
    sc.setAttribute('src', `${url}?callback=jsonp${randomStr}${paramsStr}`)
    sc.setAttribute('name', `jsonp${randomStr}`)
    sc.addEventListener('error', onError)
    document.querySelector('body').appendChild(sc)
    window[`jsonp${randomStr}`] = function (res) {
      resolve(res)
      delete window[`jsonp${randomStr}`]
      sc.removeEventListener('error', onError)
      document.querySelector('body').removeChild(document.querySelector(`script[name=jsonp${randomStr}]`))
    }

    function onError(err) {
      reject(err)
    }
  })
}

// base64 => blob
export function base64ToBlob(base64) {
  let base64Arr = base64.split(','),
    imgtype = '',
    base64String = ''
  if (base64Arr.length > 1) {
    //如果是图片base64，去掉头信息
    base64String = base64Arr[1]
    imgtype = base64Arr[0].substring(base64Arr[0].indexOf(':') + 1, base64Arr[0].indexOf(';'))
  }
  // 将base64解码
  let bytes = atob(base64String),
    bytesCode = new ArrayBuffer(bytes.length),
    byteArray = new Uint8Array(bytesCode) // 转换为类型化数组
  // 将base64转换为ascii码
  for (var i = 0; i < bytes.length; i++) {
    byteArray[i] = bytes.charCodeAt(i)
  }
  // 生成Blob对象（文件对象）
  return new Blob([bytesCode], {
    type: imgtype
  });
}


// base64 => file
export function base64ToFile(dataurl, filename) {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {
    type: mime
  })
}

export function downFileWithUrl(_url, filename) {
  let image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    console.log(234)
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    let context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    let a = document.createElement("a"); // 生成一个a元素
    let event = new MouseEvent("click"); // 创建一个单击事件
    a.download = filename || "timg"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  console.log(_url)
  image.src = _url;
};

export function isInApp() {
  const cjUserAgent = window.navigator.userAgent;
  return cjUserAgent.indexOf("HxAxClientCmWebKit") > -1;
}

export function isInAppB() {
  const cjUserAgent = window.navigator.userAgent;
  return cjUserAgent.indexOf("HxAxClientCmWebKit") > -1 && cjUserAgent.indexOf("hxAx_B") > -1;
}

export function isInAppC() {
  const cjUserAgent = window.navigator.userAgent;
  return cjUserAgent.indexOf("HxAxClientCmWebKit") > -1 && cjUserAgent.indexOf("hxAx_C") > -1;
}

export function compare(curV, reqV) {
  if (curV && reqV) {
    if (curV === reqV) return true
    // 将两个版本号拆成数字
    var arr1 = curV.split('.'),
      arr2 = reqV.split('.')
    var minLength = Math.min(arr1.length, arr2.length),
      position = 0,
      diff = 0
    // 依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
    while (
      position < minLength &&
      (diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0
    ) {
      position++
    }
    diff = diff != 0 ? diff : arr1.length - arr2.length
    // 若curV大于reqV，则返回true
    return diff > 0
  } else {
    return false
  }
}

export function isInNewJsBridgeApp() {
  if (isInApp()) {
    const curAppVersion = window.navigator.userAgent.match(
      /HxAxClientCmWebKit\/(\S*)/
    )[1]
    // 6.5.35 为 app 切换jsbridge之后的强更版本号
    return compare(curAppVersion, '6.5.35')
  }
  return false
}


export function uuid(isHasLine) {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return isHasLine ? uuid : uuid.split("-").join("");
}

// 生成随机请求标识 每一个请求的唯一字符串
export function getRequestId() {
  const fullName = Math.floor(Math.random() * 1000000);
  return new Date().getTime() + "-" + fullName;
}

export function getLocation(fn, callback) {
  wx.getLocation({
    type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
    success: function(res) {
      fn && fn(res, callback);
    },
    fail: function(data) {
      //调用失败
      fn && fn({ myErrorType: "fail", data: data }, callback);
    },
    cancel: function(data) {
      //用户取消
      fn && fn({ myErrorType: "cancel", data: data }, callback);
    }
  });
}

export const formatDate = date => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return [year, month, day].map(formatNumber).join("-");
};

export function encode(stringSign, key) {
  //此方法为HMAC-SHA256的签名方式  具体签名方法可以打印CryptoJS
  var hash = CryptoJS.HmacSHA256(stringSign, key);
  //我这里是使用16进制的方法  具体API 可以打印CryptoJS.enc
  var hashInHex = CryptoJS.enc.Hex.stringify(hash).toUpperCase();
  return hashInHex;
}
/**
 * 删除URL中指定search参数,会将参数值一起删除
 * @param {string} url 地址字符串
 * @param {array} aParam 要删除的参数key数组，如['name','age']
 * @return {string} 返回新URL字符串
*/
export function deleteUrlParam(url,aParam){
  aParam.forEach(item => {
    const fromindex = url.indexOf(`${item}=`) //必须加=号，避免参数值中包含item字符串
    if (fromindex !== -1) {
      // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
      const startIndex = url.indexOf('=', fromindex)
      const endIndex = url.indexOf('&', fromindex)
      const hashIndex = url.indexOf('#', fromindex)

      let reg;
      if (endIndex !== -1) { // 后面还有search参数的情况
        const num = endIndex - startIndex
        reg = new RegExp(`${item}=.{${num}}`)
        url = url.replace(reg, '')
      } else if (hashIndex !== -1) { // 有hash参数的情况
        const num = hashIndex - startIndex - 1
        reg = new RegExp(`&?${item}=.{${num}}`)
        url = url.replace(reg, '')
      } else { // search参数在最后或只有一个参数的情况
        reg = new RegExp(`&?${item}=.+`)
        url = url.replace(reg, '')
      }
    }
  });
  const noSearchParam = url.indexOf('=')
  if( noSearchParam === -1 ){
    url = url.replace(/\?/, '') // 如果已经没有参数，删除？号
  }
  return url
}

function serializer(data) {  //序列化
  var simpleData = ['string', 'number', 'boolean']
  var keys = Object.keys(data)
  return keys.reduce((result, key, index) => {
    var value = data[key]
    var _value = simpleData.indexOf(typeof value) ^ -1 ? value : JSON.stringify(value)

    return result + key + '=' + _value + (keys.length - 1 === index ? '' : '&')
  }, '')

}
function sort_ASCII(obj) { //对象进行ascii排序;
  var arr = new Array();
  var num = 0;
  for (var i in obj) {
    arr[num] = i;
    num++;
  }
  var sortArr = arr.sort();
  var sortObj = {};
  for (var i in sortArr) {
    sortObj[sortArr[i]] = obj[sortArr[i]];
  }
  return sortObj;
}
function sortMap (data) { //排序
  var arr = Object.keys(data).sort((prev, next) => prev.charCodeAt() - next.charCodeAt())
  return arr.reduce((result, key) => {
    result[key] = data[key]

    return result
  }, Object.create(null))
}
// 根据中台要求传参数加密
// bizBody 是{}
export function encryptParams(bizBody) {
  let appKey = getFaceConfig().appKey
  let appSecret = getFaceConfig().appSecret;
  let sortBizBody = sort_ASCII(bizBody); //排序
  let timestamp = new Date().getTime();
  let uuidStr = uuid();
  let requestId = getRequestId();
  var params = {
    timestamp: timestamp,
    randomStr: uuidStr,
    requestId: requestId,
    appKey: appKey,
    bizBody: JSON.stringify(sortBizBody)
  };
  var sortObj = sort_ASCII(params); //排序
  var str = serializer(sortObj) + "&key=" + appSecret; //序列化
  console.log("参数加密前:" + str);
  var encodeStr = encode(str, appSecret);
  console.log("参数加密后:" + encode(str, appSecret));
  return {
    requestId: requestId,
    timestamp: timestamp,
    randomStr: uuidStr,
    sign: encodeStr,
    appKey: appKey,
    bizBody: JSON.stringify(bizBody)
  }
}
export function getBindWxUrl(targetUri,token) {
  const hostName = window.location.host;
  const port = window.location.port;
  let url = window.location.href;
  if (hostName.indexOf("anxinzp.com") > -1 || !!port) {
      url = "https://s.anxinzp.com/?targetUri=" + targetUri + '&specWxtoken='+token+ "#/transferPage";
    } else if (hostName.indexOf("anxingongchang.com") > -1) {
      url ="https://s.anxingongchang.com/?targetUri=" +targetUri +'&specWxtoken='+token+"#/transferPage";
    } else if (hostName.indexOf("huixiananxin.com") > -1) {
      url = "https://s.huixiananxin.com/?targetUri=" + targetUri +'&specWxtoken='+token+ "#/transferPage";
    } else {
      url ="https://s1.yunrenshi.net/?targetUri=" + targetUri + '&specWxtoken='+token+"#/transferPage";
    }
  return url;
  //return faceConfig[key];
}
//添加更改URL参数  只适用于 参数在#之前 例如 https://s.anxinzp.com/?code=33333#/my
export function addUrlPara(url, name, value) {
  let targetUrl = url ||  window.location.href
  var currentUrl = targetUrl.split('#')[0];
  let reg = new RegExp("(^|)"+ name +"=([^&]*)(|$)");
  if (/\?/g.test(currentUrl)) {
    if (currentUrl.match(reg)!=null) {
      currentUrl = currentUrl.replace(eval(reg), name + "=" + value);
    } else {
      currentUrl += "&" + name + "=" + value;
    }
  } else {
    currentUrl += "?" + name + "=" + value;
  }
  if (targetUrl.split('#')[1]) {
    return  currentUrl + '#' + targetUrl.split('#')[1];
  } else {
    return currentUrl;
  }
}

// 去除url 的微信返回的 code 参数，并刷新页面
export const clearUrlCodeAndReloadPage = () => {
  const hash = window.location.hash;
  const origin = window.location.origin;
  // const search = ;
  const query = decodeURI(window.location.search.substring(1));
  const vars = query.split('&');
  let queryObj = {};
  let queryKeys = [];
  let queryStr = [];
  let searchText = ""
  vars.forEach(item => {
    var pair = item.split('=');
    queryKeys.push(pair[0]);
    queryObj[pair[0]] = pair[1];
  });
  queryKeys.forEach(key => {
    if (key !== "code" && key !== "state") {
      queryStr.push(`${key}=${queryObj[key]}`)
    }
  });
  if (queryStr.length > 0) {
    searchText = `?${queryStr.join("&")}`
  }
  let url = `${origin}/${searchText}${hash}`;
  window.location.replace(url);
}
// yyyy-mm-dd/yyyy-mm => yyyy年mm月dd日/yyyy年mm月
export const gettDateWidthUnit = (str = '') => {
  if (!str) return
  let dateUnit = ['年', '月', '日']
  return String(str).split('-').reduce((res, cur, i) => {
    return  res = res + cur + dateUnit[i]
  }, '')
}
